import "./style.scss";
import "regenerator-runtime/runtime";
import { CoreInitializer, RecipeTagsInjector } from "@core";
import { MonoprixIconsWrapper } from "./wrappers/monoprix-icons-wrapper";
import { MonoprixStoreWrappper } from "./wrappers/monoprix-store-wrapper";
import { MonoprixUserWrapper } from "./wrappers/monoprix-user-wrapper";
import { MonoprixRecipeInjector } from "./extend/monoprix-recipe-injector";
import { handlePayment, getBasketProducts, listenToRetailerBasket, pushProductsToBasket, resetOnEmptyBasket } from "./basket-sync";
import { MonoprixRecipeTagWrapper } from "./wrappers/monoprix-recipe-tag-wrapper";
import { Config } from "./config/config";
import { env } from '../../environments/environment.js';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////METHODS/////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/**
 * Setup for ABesting campains
 */
async function initAbTesting(config) {
  // If an a/b testing campaign is on (defined in config file)
  const abConfig = config.getAbCssUrl();
  if (abConfig) {
    console.debug('[Mealz Injector] A/B testing: config found', abConfig);
    // Define use as "a", "b", "c"... randomly
    // If user is already assigned a letter, let as is
    if (!localStorage.getItem('_miam/ab')) {
      const max = Object.keys(abConfig).length
      const rand = Math.floor(Math.random() * max);
      const version = Object.keys(abConfig)[rand];
      localStorage.setItem('_miam/ab', version);
    }

    // Configure analytics service to attach the letter to each event
    const abTestKey = localStorage.getItem('_miam/ab');
    console.debug('[Mealz Injector] A/B testing: User set to version', abTestKey);
    window.mealz.analytics.setAbTestKey(abTestKey);
    // Load the proper stylesheet using url in config file
    injectCss(abConfig[abTestKey]);

  // Otherwise, remove any previous a/b testing config kept in storage
  } else {
    console.debug('[Mealz Injector] A/B testing: no config found');
    localStorage.removeItem('_miam/ab');
  }
}

function injectCss(url) {
  // in config file, set "a": null to keep default version of stylesheet
  if (!url) {
    console.debug('[Mealz Injector] A/B testing: loading no css file');
    return;
  }

  console.debug('[Mealz Injector] A/B testing: loading css file', url);
  const head = document.head;
  const link = document.createElement("link");

  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = url;

  head.appendChild(link);
}

//////////////////////////////////////////////////////////
/////////////////OPERATIONS ON URL CHANGES////////////////
//////////////////////////////////////////////////////////

/**
 * MutationObserver to check changes in URl since Monoprix is *mostly* a SPA
 * @param {*} coreInitializer an instance of CoreInitializer so we can use the initInjector method to change suppliers
 */
 function listenToUrlChange(coreInitializer) {
  var previousUrl = location.href;
  let checkoutIsListened = false;
  // let shouldRestartCardInjection = false;
  var profilingWasPermitted = userWrapper.profilingAllowed();
  var observer = new MutationObserver(async function() {
    injectCatalogLink();
    const button = document.querySelector('[data-test="basket-checkout-button"]');
    // If the button is in the DOM we put a listener for checkout if it isn't already here
    if (button) {
      if (!checkoutIsListened) {
        checkoutIsListened = true;
        listenToCheckout();
      }
    }
    else {
      // If the button isn't in the DOM our listener isn't either
      checkoutIsListened = false;
    }
    if (location.href !== previousUrl) {
      manageSupplierUpdates(coreInitializer, previousUrl);
      previousUrl = location.href;
    }
    if (window.location.href.includes('basket')) {
      new RecipeTagsInjector(new MonoprixRecipeTagWrapper(), true);
    }
    if (window.location.href.includes('page-idees-recettes')) {
      injectCatalog();
    }
    profilingWasPermitted = listenToProfilingPermissions(profilingWasPermitted)
  });
  observer.observe(document.body, { attributes: false, childList: true, subtree: true })
}

function listenHeaderHeightChange() {
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      window.mealz.setStickyHeaderHeight(entry.contentRect.height);
    }
  });

resizeObserver.observe(document.querySelector('#main-header'));
}

/**
 * Inject the link for the catalog in the header
 */
 function injectCatalogLink() {
  injectCatalogLinkDesktop()
  injectCatalogLinkWebmobile()
}

function injectCatalogLinkDesktop(attempt = 0) {
  if(document.getElementsByClassName('miamCatalogLink').length === 0) {
    const row = document.getElementsByTagName('header')[0].children[1].children[0];
    if (row) {
      const box = document.createElement('div');
      box.classList.add('miamCatalogLink');

      const link = document.createElement('a');
      link.href = '/content/page-idees-recettes';

      const buttonContent = document.createElement('span');
      buttonContent.innerText = 'Idées repas';
      link.appendChild(buttonContent);
      box.appendChild(link);
      row.lastElementChild.after(box);
    } else if (attempt < 10) {
      // sometimes the page takes some time to initialize but we won't make more than 10 attempts to avoid infinite loop
      setTimeout(() => {
        injectCatalogLinkDesktop(attempt + 1)
      }, 50)
    }
  }
}

function injectCatalogLinkWebmobile() {
  if(document.getElementsByClassName('miamCatalogLinkMobile').length === 0) {
    const rowMobile = document.getElementById('nav-menu');
    if(rowMobile) {
      const listeDeCourse = [...rowMobile.children].filter(child => child.textContent.includes('Liste'))[0]
      if(listeDeCourse) { // if this tag exists you are on mobile, add the element here
        const box = document.createElement('li');
        box.classList.add('nav-list-item__StyledNavListItem-sc-1j9hj7k-0', 'gKbaCd');

        const link = document.createElement('a');
        link.href = '/content/page-idees-recettes';
        link.classList.add('miamCatalogLinkMobile');

        const container = document.createElement('div');
        container.classList.add("miamCatalogLinkMobile__container")

        const pictoCont = document.createElement('div');
        const picto = document.createElement('img');
        picto.setAttribute('src', 'https://storage.googleapis.com/assets.miam.tech/monoprix/icons/iconForkKnife.svg')
        pictoCont.appendChild(picto);

        const text = document.createElement('span');
        text.innerText = 'Idées repas';

        container.appendChild(pictoCont);
        container.appendChild(text);
        link.appendChild(container);
        box.appendChild(link);
        listeDeCourse.after(box)
      }
    }
  }
}

/**
 * Before, when switching to the non-al supplier, we needed to switch user too, because otherwise th food basket would be mixed with the
 * non-food basket, which could cause bugs.
 * Now we don't need to switch users but no clue if it is really necessary to reload the user with loadWithExternalId...
 */
function manageSupplierUpdates(coreInitializer, previousUrl) {
  if(window.location.href.includes('ma-liste')) {
    // Change the user to a non-al user to separate the non-al list and the currentList
    if (userWrapper.getUserId()) {
      window.mealz.user.loadWithExternalId(userWrapper.getUserId()).subscribe();
    }
    // Update supplier to non-food
    coreInitializer.initInjector(env.monoprix.nonalSupplierId);
    injectListScan();
  }
  // Update the supplier only if it was different before
  else if (previousUrl.includes('ma-liste')) {
    // Go back to the "normal" user
    if (userWrapper.getUserId()) {
      window.mealz.user.loadWithExternalId(userWrapper.getUserId()).subscribe();
    }
    // Update supplier to food
    coreInitializer.initInjector(env.monoprix.alSupplierId);
  }
}

//////////////////////////////////////////
/////////////////LIST SCAN////////////////
//////////////////////////////////////////

/**
 * Inject the list-scan component in place of the two buttons of their page
 */
function injectListScan(attempt = 0) {
  if(!document.querySelector('webc-miam-list-scan')) {
    const row = document.getElementsByClassName('row-m')[document.getElementsByClassName('row-m').length - 1];
    if(row) {
      const container = row.firstElementChild;
      const list = document.createElement('webc-miam-list-scan');
      list.isSchoolList = true;
      container.replaceWith(list);
    }
    else if (attempt < 10) {
      // sometimes the page takes some time to initialize but we won't make more than 10 attempts to avoid infinite loop
      setTimeout(() => {
        injectListScan(attempt + 1)
      }, 50)
    }
  }
}

//////////////////////////////////////////////////
/////////////////CATALOG INJECTION////////////////
//////////////////////////////////////////////////

/**
 * Inject the link for the catalog in the header
 */
 function injectCatalog(attempt = 0) {
  if(!document.querySelector('webc-miam-recipe-catalog')) {
    let container = document.getElementById('main')
    if(container?.firstChild) {

      const catalogComponent = document.createElement('webc-miam-recipe-catalog');
      catalogComponent.displayInfos = true;
      container.firstChild.appendChild(catalogComponent);

      // Avoid header 90px offset
      const catalogAnchor = catalogComponent.getElementsByClassName('miam-catalog-anchor')[0];
      catalogAnchor.scrollIntoView = function() {
        window.scrollTo(0, 0);
      }
    }
    else if (attempt < 10) {
      // sometimes the page takes some time to initialize but we won't make more than 10 attempts to avoid infinite loop
      setTimeout(() => {
        injectCatalog(attempt + 1);
      }, 50)
    }
  }
}

////////////////////////////////////////////////
/////////////////OTHER LISTENERS////////////////
////////////////////////////////////////////////

/**
 * Listen to click on checkout button and add total order price to localStorage
 */
function listenToCheckout() {
  const button = document.querySelector('[data-test="basket-checkout-button"]');
  button.addEventListener('click', () => {
    const footer = document.getElementById('drawer-footer');
    let total = undefined;
    if (footer) {
      // Get the price in span - format of innerHTML is "00,00&nbsp;€"
      total = footer.firstChild.children[1].innerHTML.split('&nbsp;')[0];
    }
    else {
      // Get the price in span - format of innerHTML is "00,00&nbsp;€"
      total = document.querySelector('[data-test="summary-items-description"]').firstChild.innerHTML.split('&nbsp;')[0];
    }
    const totals = total.split(',');
    const totalPrice = parseInt(totals[0]) + parseInt(totals[1])/100;
    // You can't confirm your basket under 50€ of basket price on Monoprix
    if (totalPrice >= 50 && totalPrice.toString() !== localStorage.getItem('miam-payment-total')) {
      localStorage.setItem('miam-payment-total', totalPrice)
      window.mealz.paymentStarted(totalPrice);
    }
  })
}

/**
 * On Monoprix, changing the user's cookies permission doesn't reload the page, so we need to listen for it
 */
function listenToProfilingPermissions(wasPermitted) {
  const isPermitted = userWrapper.profilingAllowed()
  if (isPermitted !== wasPermitted) {
    if (userWrapper.getUserId()) {
      window.mealz.user.loadWithExternalId(userWrapper.getUserId(), !isPermitted, true).subscribe();
    }
  }
  return isPermitted;
}


/**
 * We have to reload the page to update Monoprix's cart, so we reload the page if the details is closed and the basket 
 * was updated while it was opened.
 */
function listenToRecipeAdd() {
  const modal = document.querySelector('webc-miam-recipe-modal');
  modal.detailsStepsOnLeftSide = true;
  modal.detailsPricingGuestsText = "/pers.";
  modal.detailsMoreRecipesImageURL = "https://storage.googleapis.com/assets.miam.tech/monoprix/images/details-additionnal-image.jpeg";
  modal.addEventListener('hasChangesOnClose', (hasChanges) => {
    if (hasChanges.detail) {
      removeDisplayRecipeFromUrlQueryAndReload()
    }
  });
}

/**
 * We have to reload the page to update Monoprix's cart, but we reload the page if the details is closed and the basket 
 * was updated while it was opened. So if the details opens again after reloading because the displayRecipe param was still 
 * in url, the basket will be updated while it is reopened, since it will be initialized during that time.
 * So we need to prevents tjhe details from reopening after the page reload
 */
function removeDisplayRecipeFromUrlQueryAndReload() {
  let url = window.location.href;
  const filteredSearch = url.split('?')[1];
  if (filteredSearch) {
    const params = new URLSearchParams(filteredSearch);
    params.delete('displayRecipe');
    const filteredQueryString = params.toString();
    if (filteredQueryString) {
      url = url.replace(filteredSearch, filteredQueryString);
    } else {
      url = url.split('?')[0];
    }
  }
  window.location.href = url
}

function replaceBasketTotal(price, count) {
  const bContainer = document.querySelector("button[data-test=basket-button]");
  const bPrice = bContainer?.querySelector("span[data-test=basket-price]");
  const bCount = bContainer?.querySelector("span[data-test=basket-counter]");
  if (bPrice) {
    bPrice.textContent = price.toFixed(2).replace(".", ",") + " €";
  }
  if (bCount) {
    bCount.textContent = count.toString();
  }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////SCRIPT INIT////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const config = Config;
const userWrapper = new MonoprixUserWrapper();
init();

async function init() {
  await config.initConfig()
  window.mealz.supplier.setOrigin('monoprix')
  initAbTesting(config);
  window.mealz.setDefaultScrollElementGetter(() => document.getElementsByTagName('html')[0])
  const storeWrapper = new MonoprixStoreWrappper(config);
  new MonoprixIconsWrapper();
  let coreInitializer;
  /**
   * At some point, Monoprix's cart was broken on startup (after adding a recipe to cart, maybe?)
   * So this is us repairing their cart for them...
   * No clue if this is still necessary, we'd have to test
   */
  if (window.__INITIAL_STATE__.data.basket.unavailableData) {
    const products = getBasketProducts();
    let total_price = 0.00;
    let total_count = 0;
    products.forEach(p => {
      total_price += p.price * p.quantity;
      total_count += p.quantity;
    })
    replaceBasketTotal(total_price, total_count);
  }
  
  /**
   * Monoprix is the only supplier for which we have activated the list-scan feature. This feature is to be used in context
   * of buying the school supplies at the start of the year, which means we have to deal with non-food items. The way we 
   * make it work is by having to supplies in DB for Monoprix: 10 - Monoprix al (food) and 11 - Monoprix non-al (non-food)
   * We switch between the two suppliers depending on the page, loading the "non-al" supplier only for the scan-list page.
   */
  ////////////////SUPPLIER INIT (AL / NON-AL)////////////////
  if(window.location.href.includes('ma-liste')) {
    coreInitializer = new CoreInitializer(env.monoprix.nonalSupplierId, userWrapper, storeWrapper, userWrapper.analyticsDomain());
    if (userWrapper.getUserId()) {
      window.mealz.user.loadWithExternalId(userWrapper.getUserId(), false, true).subscribe();
    }
    injectListScan();
  }
  else {
    coreInitializer = new CoreInitializer(env.monoprix.alSupplierId, userWrapper, storeWrapper, userWrapper.analyticsDomain());
    if (userWrapper.getUserId()) {
      window.mealz.user.loadWithExternalId(userWrapper.getUserId(), !userWrapper.profilingAllowed(), true).subscribe();
    }
  }
  
  ////////////////INIT BASKET SYNC////////////////
  // Map methods for baskets synchronization between Miam and me
  window.mealz.basketSync.definePushProductsToBasket(pushProductsToBasket)
  // Init baskets synchronization between Miam and me
  handlePayment();
  listenToRetailerBasket();
  listenToRecipeAdd();
  resetOnEmptyBasket();
  
  /**
   * Components are only injected if:
   * - on preprod or
   * - user is not logged or
   * - user is logged but store is not Paris
   */
  if (
    window.location.href.includes('https://www.rte.casino.osp.world') ||
    !userWrapper.getUserId() ||
    storeWrapper.availableOnPage()
    ) {
  
    ////////////////HEADER LINK INJECTION////////////////
    /**
     * On Monoprix we have to inject the link to the catalog page ourselves in header
     */
    window.mealz.router.setRecipeCatalogUrl('/content/page-idees-recettes');
    injectCatalogLink();
  
    ////////////////URL CHANGE LISTENER////////////////
    // Init MutationObserver used for all things that require a MutationObserver so we don't multiply them too much
    listenToUrlChange(coreInitializer);
    listenHeaderHeightChange();
  
    ////////////////CARDS INJECTION////////////////
  
    // Start recipe injection
    new MonoprixRecipeInjector(storeWrapper);
  
    /**
     * Inject the recipe-tags on the basket page of Monoprix. The feature is old and we do not maintain it much,
     * but Monoprix wants us to maintain it
     */
    ////////////////BASKET TAGS INJECTION////////////////
    if (window.location.href.includes('basket')) {
      new RecipeTagsInjector(new MonoprixRecipeTagWrapper(), true);
    }
  
    ////////////////CATALOG INJECTION////////////////
    if (window.location.href.includes('page-idees-recettes')) {
      injectCatalog();
    }
  
    // Monoprix have confirmation toasters for basket actions, so we show a toaster when adding a recipe to the basket
    window.mealz.recipes.showConfirmationToaster();
    window.mealz.features.enableGuestsInputOnMyMeals();
  }
}
